import type { ViewNode } from "@e308/ux";
import type { AppIntent } from "./app-source.js";

export function computerTownHelp(): ViewNode<AppIntent, string> {
  return {
    kind: "help",
    id: "computer-town-help",
    targetId: "ai-count",
    label: "About Clockwork opponents",
    triggerLabel: "i · About computer towns",
    content: [
      {
        kind: "description",
        id: "computer-town-help-text",
        content: [
          {
            kind: "text",
            value:
              "Clockwork 1, Clockwork 2, and later numbers are separate computer-controlled rival towns.",
          },
        ],
      },
    ],
    presentation: "popover",
    preview: true,
    previewDelayMs: 120,
    previewMoveDismissPx: 24,
  };
}
